import React from "react";
import { Button, Modal } from "@mui/material";
import styles from "./ViewBookModal.module.scss";
import { IBook } from "@/store/models/books.models";
import moment from "moment";

type Props = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  selectedBook: IBook;
};

export const ViewBookModal = ({ isOpen, setIsOpen, selectedBook }: Props) => {
  return (
    <Modal
      aria-labelledby="view-modal"
      open={isOpen}
      onClose={() => setIsOpen(false)}
    >
      <div className={styles.modalContainer}>
        <div className={styles.modalContent}>
          <img
            className={styles.modalImg}
            src={selectedBook.imgs[0]}
            alt="book img"
          />
          <h3 className={styles.modalTitle}>{selectedBook.title}</h3>
          <div className={styles.modalInfo}>
            <span>
              {moment(selectedBook.createdAt).format("DD.MM.YYYY")}
              <br />
              <span className={styles.modalInfoDate}>Date</span>
            </span>
            <span className={styles.modalInfoLine}></span>
            <span>
              {selectedBook.storyText.length} <br />
              <span className={styles.modalInfoPages}> No. of Pages</span>
            </span>
          </div>

          <div className={styles.modalBookContent}>
            {selectedBook.storyText.map((item, index) => (
              <section key={index} className={styles.modalBookContentParagraph}>
                {selectedBook.imgs[index] && (
                  <img
                    className={styles.modalBookContentImg}
                    src={selectedBook.imgs[index]}
                    alt={`paragraph img ${index + 1}`}
                  />
                )}
                <div className={styles.modalBookContentDescr}>{item.text}</div>
                <h4>{++index}</h4>
              </section>
            ))}
          </div>
        </div>
        <Button
          variant="outlined"
          fullWidth
          sx={{
            textTransform: "capitalize",
            height: "44px",
            border: "1px solid #5570F1",
            color: "#5570F1",
            borderRadius: "12px",
          }}
          onClick={() => setIsOpen(false)}
        >
          Close
        </Button>
      </div>
    </Modal>
  );
};
